import { Dropdown, Input } from 'components';
import React, { useEffect, useState } from 'react';

const rounds = [
  {
    value: 'Friendly',
    opt: 'friendly'
  },
  {
    value: 'Qualification',
    opt: 'qualification'
  },
  {
    value: 'Group Stage',
    opt: 'group_stage'
  },
  {
    value: 'Round of 64',
    opt: 'round_of_64'
  },
  {
    value: 'Round of 32',
    opt: 'round_of_32'
  },
  {
    value: 'Round of 16',
    opt: 'round_of_16'
  },
  {
    value: 'Quarter Finals',
    opt: 'quarter_finals'
  },
  {
    value: 'Semi Finals',
    opt: 'semi_finals'
  },
  {
    value: 'Third Place Playoff',
    opt: 'third_place_playoff'
  },
  {
    value: 'Final',
    opt: 'final'
  },
  {
    value: 'Regular Season',
    opt: 'regular_season'
  },
  {
    value: 'Play Offs',
    opt: 'play_offs'
  },
  {
    value: 'Preseason',
    opt: 'preseason'
  }
];

const Round = ({ round, setRound, matchNumber, setMatchNumber, data }) => {
  const [visibleRound, setVisibleRound] = useState(null);

  useEffect(() => {
    if (!data) return;

    handleRound({ opt: data.round }, true);
  }, []);

  function handleRound(round, isInitial) {
    const foundRound = rounds.find((x) => x.opt === round.opt);

    if (foundRound) {
      setVisibleRound(foundRound);
      setRound(foundRound.opt);
      
      // If it's regular_season and initial load, set the matchNumber from data
      if (foundRound.opt === 'regular_season') {
        if (isInitial && data.matchNumber) {
          setMatchNumber(data.matchNumber.toString());
        } else if (!isInitial) {
          setMatchNumber('');
        }
      } else {
        setMatchNumber(null);
      }
      return;
    }

    // Fallback to first option
    setVisibleRound(rounds[0]);
    setRound(rounds[0].opt);
    setMatchNumber(null);
  }

  function handleMatchNumber(e) {
    const value = e.target.value;
    const reg = /^\d+$/;
    if (value !== '' && !reg.test(e.target.value)) return;

    setMatchNumber(e.target.value);
  }

  return (
    <React.Fragment>
      <Dropdown
        title="Round"
        admin
        rounded
        wid="100%"
        options={rounds}
        placeholder="Select..."
        selected={visibleRound}
        bg="#fff"
        marg="24px 0 0"
        handleSelect={(e) => handleRound(e)}
      />

      {visibleRound?.opt === 'regular_season' && (
        <Input
          marg="24px 0 0"
          title="Match Number"
          placeholder="32"
          value={matchNumber}
          onChange={handleMatchNumber}
        />
      )}
    </React.Fragment>
  );
};

export default Round;
